import React, {useEffect, useState} from 'react'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Select from 'react-select'
import Text from '#components/a/Text'
import Option from '#components/m/Status/StatusSelectOption'
import SingleValue from '#components/m/Status/StatusSelectSingleValue'
import Loading from '#components/a/Loading'

export const AbteilungSelect = ({
  readAzubiAbteilungen,
  azubiId,
  onSelectAbteilung,
  versetzungsplan,
  abteilungen,
  selectedAbteilungId,
  abteilungenLoading,
}) => {
  const [options, setOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState({})
  const [style, setStyle] = useState({})

  useEffect(() => {
    if (azubiId) {
      readAzubiAbteilungen({azubiId})
    }
  }, [azubiId])

  useEffect(() => {
    if (options && options.length > 0) {
      if (selectedAbteilungId === undefined) {
        onSelectAbteilung(options[0].value)
      } else {
        setSelectedOption(options.find(o => o.value === selectedAbteilungId) || options[0])
      }
    }
  }, [selectedAbteilungId, options])

  useEffect(() => {
    if (abteilungen && versetzungsplan) {
      let options = abteilungen.map(abt => {
        const abteilung = versetzungsplan?.abteilungsZeiten?.find(p => p.abteilungId === abt.abteilungId)
        return {
          value: abt.abteilungId,
          label: abt.name,
          backgroundColor: abt.backgroundColor,
          textColor: abt.textColor,
          tasksDone: abteilung?.istZeit || 0,
          tasksTotal: abt.sollZeit,
        }
      })
      setOptions(options)
      if (selectedAbteilungId) {
        setSelectedOption(options.find(o => o.value === selectedAbteilungId))
      } else if (options && options.length > 0) {
        onSelectAbteilung(options[0].value)
      }
    }
  }, [abteilungen, versetzungsplan, selectedAbteilungId])

  useEffect(() => {
    if (selectedOption) {
      setStyle({
        control: (styles, state) => ({
          ...styles,
          backgroundColor: selectedOption.backgroundColor,
          border: 0,
          boxShadow: 0,
          '&:hover': {
            border: 0,
          },
        }),
        singleValue: styles => ({
          ...styles,
          color: selectedOption.textColor,
        }),
        dropdownIndicator: styles => ({
          ...styles,
          color: selectedOption.textColor,
        }),
      })
    }
  }, [selectedOption])

  return (
    <div className="abteilungSelect">
      <Text text={i18n.t('abteilung_erstellen_abteilung_label')} />
      {abteilungenLoading || !options ? (
        <Loading />
      ) : (
        <Select
          styles={style}
          className="dropdownSelect"
          classNamePrefix="dropdownSelect"
          value={selectedOption}
          onChange={evt => {
            onSelectAbteilung(evt.value)
          }}
          options={options}
          components={{Option, SingleValue}}
          isDisabled={options.length === 0}
        />
      )}
    </div>
  )
}

AbteilungSelect.propTypes = {
  azubiId: PropTypes.number,
  abteilungen: PropTypes.array,
  versetzungsplan: PropTypes.object,
  selectedAbteilungId: PropTypes.number,
  onSelectAbteilung: PropTypes.func,
  readAzubiAbteilungen: PropTypes.func,
  abteilungenLoading: PropTypes.bool,
}

const mapStateToProps = (state, props) => {
  const versetzungsplan = props.versetzungsplaene.find(vp => vp.userId === props.azubiId)
  return {
    abteilungen: state.versetzungsplan.abteilungen,
    abteilungenLoading: state.versetzungsplan.isLoadingAbteilungen,
    versetzungsplan,
  }
}

function mapDispatchToProps() {
  return {
    readAzubiAbteilungen: actions.versetzungsplan.readAzubiAbteilungen,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AbteilungSelect)
